module.exports = __webpack_public_path__ + "img/email.e3ccdb29.png";